import type { ReactNode } from 'react'

import { EmptyState, LoadingBlock } from '@/design'

/** The part of a react-query result a card body reads. */
interface QueryLike<T> {
  isPending: boolean
  isError: boolean
  data: T | undefined
}

/**
 * One Overview card's body state, in one place and in one order: loading, an
 * outage, and the card's own content once there is an answer. Loading and
 * outage stay independent of the content, as they always were: a failed
 * refetch keeps the previous figures on screen beneath its outage notice.
 */
export function CardQueryBody<T>({
  query,
  loadingRows,
  loadingLabel,
  errorDescription,
  children,
}: {
  query: QueryLike<T>
  loadingRows: number
  loadingLabel?: string
  errorDescription: string
  children: (data: T) => ReactNode
}) {
  return (
    <>
      {query.isPending ? <LoadingBlock rows={loadingRows} label={loadingLabel} /> : null}
      {query.isError ? <EmptyState variant="outage" compact description={errorDescription} /> : null}
      {query.data !== undefined ? children(query.data) : null}
    </>
  )
}
